import { Injectable } from '@angular/core';

@Injectable()
export class NotifyService {

    info(message: string, title?: string, options?: any): void {
        solid.notify.info(message, title, options);
    }

    success(message: string, title?: string, options?: any): void {
        solid.notify.success(message, title, options);
    }

    warn(message: string, title?: string, options?: any): void {
        solid.notify.warn(message, title, options);
    }

    error(message: string, title?: string, options?: any): void {
        solid.notify.error(message, title, options);
    }

}